"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ThreadHistory;
var _react = _interopRequireWildcard(require("react"));
var _constants = require("./constants");
var _threadStore = require("./threadStore");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const HISTORY_URL = "".concat(process.env.REACT_APP_CHAT_AGENT_DOMAIN || '', "/v1/ai/audit/history");
const MOCK_URL = '/auditHistory.json';
const USE_MOCK = process.env.REACT_APP_DEVELOPMENT_MODE === 'enabled';
const PAGE_SIZE = 10;
function getAuthHeaders() {
  const headers = {
    'Content-Type': 'application/json',
    'X-Upstream-Env': process.env.REACT_APP_HCP_ENV
  };
  try {
    const clientId = process.env.REACT_APP_USER_POOL_CLIENT_ID;
    if (clientId) {
      const userKey = localStorage.getItem("CognitoIdentityServiceProvider.".concat(clientId, ".LastAuthUser"));
      if (userKey) {
        const jwt = localStorage.getItem("CognitoIdentityServiceProvider.".concat(clientId, ".").concat(userKey, ".idToken"));
        if (jwt) headers['Authorization'] = "Bearer ".concat(jwt);
      }
    }
  } catch (_unused) {}
  return headers;
}
function apiThreadsToInternal(threads) {
  return (threads || []).map(t => {
    var _msgs, _msgs$;
    const msgs = (t.messages || []).map(m => {
      var _m$message;
      const role = m.role === 'agent' ? 'assistant' : m.role;
      const rawMsg = role === 'user' ? (_m$message = m.message) === null || _m$message === void 0 || (_m$message = _m$message.body) === null || _m$message === void 0 ? void 0 : _m$message.message : null;
      const text = typeof rawMsg === 'string' ? rawMsg : rawMsg !== null && rawMsg !== void 0 && rawMsg.type ? "Action: ".concat(rawMsg.type) : '';
      const json = role === 'assistant' ? {
        message: m.message
      } : null;
      return {
        role,
        text,
        json,
        createdAt: m.timestamp
      };
    }).sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
    return {
      id: t.thread_id,
      backendThreadId: t.thread_id,
      messages: msgs,
      updatedAt: t.last_activity || ((_msgs = msgs[msgs.length - 1]) === null || _msgs === void 0 ? void 0 : _msgs.createdAt) || new Date().toISOString(),
      createdAt: ((_msgs$ = msgs[0]) === null || _msgs$ === void 0 ? void 0 : _msgs$.createdAt) || t.last_activity,
      status: _constants.THREAD_STATUS.ACTIVE,
      title: '',
      featureType: detectFeatureFromMessages(msgs)
    };
  });
}
function detectFeatureFromMessages(msgs) {
  const userMsg = msgs.find(m => m.role === 'user');
  if (!(userMsg !== null && userMsg !== void 0 && userMsg.text)) return null;
  const txt = userMsg.text.toLowerCase();
  if (txt.includes('eid insight') || txt.includes('show eid')) return 'EID_INSIGHTS';
  if (txt.includes('incident') || txt.includes('inc')) return 'INCIDENT_ANALYSIS';
  if (txt.includes('data retrieval') || txt.includes('record') || txt.includes('aggregate') || txt.includes('cdc') || txt.includes('dynamo')) return 'DATA_RETRIEVAL';
  return null;
}
function bucket(dateStr) {
  const d = new Date(dateStr);
  const now = new Date();
  const diffMs = now - d;
  const dayMs = 86400000;
  if (diffMs < dayMs && d.getDate() === now.getDate()) return 'Today';
  if (diffMs < 2 * dayMs) return 'Yesterday';
  if (diffMs < 7 * dayMs) return 'Last 7 days';
  return 'Older';
}
function groupThreads(threads) {
  const groups = {};
  const order = ['Today', 'Yesterday', 'Last 7 days', 'Older'];
  threads.filter(t => t.status !== _constants.THREAD_STATUS.ARCHIVED).sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)).forEach(t => {
    const b = bucket(t.updatedAt);
    if (!groups[b]) groups[b] = [];
    groups[b].push(t);
  });
  return order.filter(k => groups[k]).map(k => ({
    label: k,
    threads: groups[k]
  }));
}
function relativeTime(dateStr) {
  const d = new Date(dateStr);
  const diff = Date.now() - d.getTime();
  if (diff < 60000) return 'just now';
  if (diff < 3600000) return "".concat(Math.floor(diff / 60000), "m ago");
  if (diff < 86400000) return "".concat(Math.floor(diff / 3600000), "h ago");
  return d.toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric'
  });
}
function lastSnippet(thread) {
  var _last$json;
  const last = [...thread.messages].reverse().find(m => m.role === 'assistant');
  if (!last) return '';
  const txt = last.text || ((_last$json = last.json) !== null && _last$json !== void 0 && (_last$json = _last$json.message) !== null && _last$json !== void 0 && _last$json.result ? 'Structured response' : '');
  return txt.length > 60 ? txt.slice(0, 57) + '…' : txt;
}
function ThreadHistory(_ref) {
  let {
    threads,
    activeThreadId,
    onSelect,
    onImportThread,
    onNew,
    onDelete
  } = _ref;
  const [apiThreads, setApiThreads] = (0, _react.useState)([]);
  const [loading, setLoading] = (0, _react.useState)(false);
  const [loadingMore, setLoadingMore] = (0, _react.useState)(false);
  const [currentPage, setCurrentPage] = (0, _react.useState)(1);
  const [hasMore, setHasMore] = (0, _react.useState)(false);
  const [totalCount, setTotalCount] = (0, _react.useState)(0);
  const didFetch = (0, _react.useRef)(false);
  const fetchHistory = (0, _react.useCallback)(async function () {
    let page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    const isInitial = page === 1;
    if (isInitial) setLoading(true);else setLoadingMore(true);
    try {
      let data;
      if (USE_MOCK) {
        const res = await fetch(MOCK_URL);
        data = await res.json();
      } else {
        const res = await fetch(HISTORY_URL, {
          method: 'POST',
          headers: getAuthHeaders(),
          body: JSON.stringify({
            page_limit: PAGE_SIZE,
            page
          })
        });
        if (!res.ok) throw new Error("HTTP ".concat(res.status));
        data = await res.json();
      }
      const newThreads = apiThreadsToInternal(data.threads || []);
      setApiThreads(prev => {
        const existingIds = new Set(prev.map(t => t.id));
        const unique = newThreads.filter(t => !existingIds.has(t.id));
        return [...prev, ...unique];
      });
      setCurrentPage(data.page || page);
      setTotalCount(data.total_threads || 0);
      setHasMore(!!data.has_next);
    } catch (err) {
      console.error('Failed to load thread history:', err);
    } finally {
      setLoading(false);
      setLoadingMore(false);
    }
  }, []);
  (0, _react.useEffect)(() => {
    if (didFetch.current) return;
    didFetch.current = true;
    fetchHistory();
  }, [fetchHistory]);
  const sessionIds = new Set(threads.map(t => t.id));
  const sessionBackendIds = new Set(threads.map(t => t.backendThreadId).filter(Boolean));
  const apiThreadIds = new Set(apiThreads.map(t => t.id));
  const mergedThreads = [...threads, ...apiThreads.filter(t => !sessionIds.has(t.id) && !sessionBackendIds.has(t.id))];
  const handleSelect = t => {
    if (apiThreadIds.has(t.id) && !sessionIds.has(t.id) && onImportThread) {
      onImportThread(t);
    } else {
      onSelect(t.id);
    }
  };
  const groups = groupThreads(mergedThreads);
  const loadedCount = apiThreads.length + threads.length;
  return (0, _jsxRuntime.jsxs)("aside", {
    style: {
      width: '320px',
      minWidth: '280px',
      borderRight: '1px solid rgba(0,0,0,0.06)',
      background: 'rgba(255,255,255,0.6)',
      backdropFilter: 'blur(16px)',
      display: 'flex',
      flexDirection: 'column',
      overflowY: 'auto',
      fontFamily: '"Inter", "Segoe UI", system-ui, -apple-system, sans-serif'
    },
    children: [(0, _jsxRuntime.jsxs)("div", {
      className: "tw-flex tw-items-center tw-justify-between tw-px-3.5 tw-pt-3.5 tw-pb-2.5 tw-border-b tw-border-sa-border",
      children: [(0, _jsxRuntime.jsx)("h3", {
        className: "tw-text-[15px] tw-font-bold tw-m-0",
        children: "Conversations"
      }), (0, _jsxRuntime.jsx)("button", {
        className: "tw-bg-sa-primary tw-text-white tw-border-none tw-cursor-pointer tw-rounded-md tw-font-semibold tw-px-2.5 tw-py-1 tw-text-[11px] tw-font-sa hover:tw-bg-sa-primary-h tw-transition-colors",
        onClick: onNew,
        children: "+ New"
      })]
    }), loading && (0, _jsxRuntime.jsxs)("div", {
      className: "tw-flex tw-flex-col tw-items-center tw-py-8 tw-gap-2",
      children: [(0, _jsxRuntime.jsx)("div", {
        style: {
          width: 24,
          height: 24,
          border: '2.5px solid #e0e0e0',
          borderTopColor: '#367796',
          borderRadius: '50%',
          animation: 'sa-spin .7s linear infinite'
        }
      }), (0, _jsxRuntime.jsx)("span", {
        className: "tw-text-[12px] tw-text-sa-text-muted",
        children: "Loading conversations\u2026"
      })]
    }), !loading && groups.length === 0 && (0, _jsxRuntime.jsx)("p", {
      className: "tw-p-5 tw-text-center tw-text-sa-text-muted tw-text-[13px]",
      children: "No conversations yet."
    }), !loading && groups.map(g => (0, _jsxRuntime.jsxs)("div", {
      className: "tw-py-1.5",
      children: [(0, _jsxRuntime.jsx)("span", {
        className: "tw-block tw-px-3.5 tw-py-1 tw-text-[11px] tw-font-semibold tw-text-sa-text-muted tw-uppercase tw-tracking-wider",
        children: g.label
      }), g.threads.map(t => {
        const meta = t.featureType ? _constants.FEATURE_META[t.featureType] : null;
        const isActive = t.id === activeThreadId;
        return (0, _jsxRuntime.jsxs)("button", {
          className: "tw-group tw-block tw-w-full tw-text-left tw-px-3.5 tw-py-2.5 tw-border-none tw-bg-transparent tw-cursor-pointer tw-font-sa tw-relative tw-transition-colors hover:tw-bg-sa-surface-alt ".concat(isActive ? 'tw-bg-sa-primary-lt tw-border-l-[3px] tw-border-l-sa-primary' : ''),
          onClick: () => handleSelect(t),
          children: [(0, _jsxRuntime.jsxs)("div", {
            className: "tw-flex tw-items-baseline tw-justify-between tw-gap-2",
            children: [(0, _jsxRuntime.jsx)("span", {
              className: "tw-text-[13px] tw-font-semibold tw-text-sa-text tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis tw-flex-1",
              children: (0, _threadStore.autoTitle)(t)
            }), (0, _jsxRuntime.jsx)("span", {
              className: "tw-text-[10px] tw-text-sa-text-muted tw-flex-shrink-0",
              children: relativeTime(t.updatedAt)
            })]
          }), (0, _jsxRuntime.jsxs)("div", {
            className: "tw-flex tw-items-center tw-gap-1.5 tw-mt-0.5",
            children: [meta && (0, _jsxRuntime.jsxs)("span", {
              className: "tw-text-[10px] tw-font-semibold tw-px-[7px] tw-py-px tw-rounded-lg tw-flex-shrink-0",
              style: {
                background: "color-mix(in srgb, ".concat(meta.color, " 14%, transparent)"),
                color: meta.color
              },
              children: [meta.icon, " ", meta.title]
            }), (0, _jsxRuntime.jsx)("span", {
              className: "tw-text-xs tw-text-sa-text-muted tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis",
              children: lastSnippet(t)
            })]
          }), (0, _jsxRuntime.jsx)("button", {
            className: "tw-absolute tw-top-2 tw-right-2 tw-bg-transparent tw-border-none tw-cursor-pointer tw-text-sa-text-muted tw-text-xs tw-opacity-0 group-hover:tw-opacity-100 tw-transition-opacity tw-px-1 tw-py-0.5 tw-rounded hover:tw-text-sa-error hover:tw-bg-red-50",
            onClick: e => {
              e.stopPropagation();
              onDelete(t.id);
            },
            title: "Delete",
            "aria-label": "Delete conversation",
            children: "\u2715"
          })]
        }, t.id);
      })]
    }, g.label)), !loading && hasMore && (0, _jsxRuntime.jsx)("div", {
      className: "tw-px-3.5 tw-py-3 tw-border-t tw-border-sa-border",
      children: (0, _jsxRuntime.jsx)("button", {
        className: "tw-w-full tw-py-2 tw-rounded-md tw-border tw-border-sa-border tw-bg-transparent tw-text-sa-text-sec tw-text-[12px] tw-font-semibold tw-font-sa tw-cursor-pointer tw-transition-colors hover:tw-bg-sa-surface-alt hover:tw-text-sa-primary hover:tw-border-sa-primary disabled:tw-opacity-50 disabled:tw-cursor-default",
        onClick: () => fetchHistory(currentPage + 1),
        disabled: loadingMore,
        children: loadingMore ? (0, _jsxRuntime.jsxs)("span", {
          className: "tw-inline-flex tw-items-center tw-gap-1.5",
          children: [(0, _jsxRuntime.jsx)("span", {
            style: {
              display: 'inline-block',
              width: 12,
              height: 12,
              border: '2px solid #ccc',
              borderTopColor: '#367796',
              borderRadius: '50%',
              animation: 'sa-spin .7s linear infinite'
            }
          }), "Loading\u2026"]
        }) : (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: ["Show older conversations", totalCount > 0 ? " (".concat(loadedCount, " of ").concat(totalCount, ")") : '']
        })
      })
    })]
  });
}